import { DirectionCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function DirectionFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return (
    <DirectionCommandList
      multiselect
      selected={selection as unknown as boolean[]}
      onSelect={onSelect as unknown as (ids: boolean[]) => void}
    />
  )
}
